// extracted by mini-css-extract-plugin
export default {"statePropertyManager":"StatePropertyManager_statePropertyManager__TIC+N"};